export const NODE = {
  DEFAULT_WIDTH: 180,
  MIN_HEIGHT: 60,
  SOCKET_SPACING: 24,
  DESCRIPTION_HEIGHT: 40,
} as const;

export const STATUS_COLORS: Record<string, string> = {
  active: '#10b981',
  deprecated: '#ef4444',
  planned: '#f59e0b',
  legacy: '#94a3b8',
};
